import { createContext } from 'react';
import { compileTimeConfig } from '../../constants/config';
import { Config } from '../../models/config';

export const ConfigContext = createContext<Config>(compileTimeConfig);
